<template>
    <div class="relative text-white p-1 rounded-md " @click="list_OnClick">
        <i class="fa-solid fa-list fa-2xl" ></i>
    
    <div class="list_full_container absolute bg-[rgba(93,93,152,0.55)] text-white p-1 right-8 top-12 text-sm rounded-md" v-if="show_filter_list">
      
        <div class="filter_entry flex justify-center  items-center gap-2" v-for="filter in filter_data" :key="filter.filter_name">
            <div class="filter_text">
                {{ filter.filter_name }}
            </div>

            <div class="filter_check" @click="check_OnClick(filter)">
                <i :class="filter.filter_visibility ? 'fas fa-check-square' : 'far fa-square'"></i>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name:'AppFilterList',
        props:{
            filter_data:{
                type: Array,
                default:() => [
                    {name:"filter1", active:true},
                    {name:"filter2", active:true},
                    {name:"filter3", active:true},
                ]
            }
        },
        mounted(){
            this.filter_state=this.filter_data;
        },
        methods:{
            list_OnClick(){
                this.show_filter_list=!this.show_filter_list;
            },
            check_OnClick(filter){
                console.log("check clicked")
                filter.filter_visibility=!filter.filter_visibility;
            }
        },
        data() {
            return {
                show_filter_list: false,
                filter_state: {},
            };
        },
    }
</script>

<style>
   /* .list_container{
        padding-right: 1rem;
        height: 48px;
        width: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .list_full_container{
        background-color: #4D4D6C;
        border-radius: 17px;
        max-width: 300px;
        max-height: 437px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
        position: absolute;
        margin-top: 3.5rem; 
        left: 50%; 
        transform: translateX(-50%); 
        padding: 1rem 2rem;
    }
    .filter_entry{
        display: flex;
       
        gap: 0.5rem;
    }

    .filter_text{
        font-size: 10px;
        color: white;
    }
    .filter_check{
        width: 25px;
        height: 25px;
        cursor: pointer;
    }

    .filter_check img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    } */

</style>
